module.exports = __webpack_public_path__ + "img/Cat.cd6852b2.png";